import { OrderOperationType } from 'api/types/entity';
import { useField } from 'modules/order/common/forms/orderForm';
import { ClientAutocompleteFeatureProps } from 'modules/order/createOrder/features';
import { useCreateOrderContext } from 'modules/order/createOrder/providers/OrderProvider';

export const useClientSection = () => {
  const { orderType } = useCreateOrderContext();

  const { field: clientTypeField } = useField('clientType');
  const { helpers: clientHelpers } = useField('client');

  const { helpers: senderAccountNumberHelpers } = useField(
    `senderDetails.accountNumber`
  );
  const { helpers: senderAccountOwnerNameHelpers } = useField(
    `senderDetails.accountOwnerName`
  );
  const { helpers: recipientAccountOwnerNameHelpers } = useField(
    `recipientDetails.accountOwnerName`
  );
  const { helpers: recipientAccountNumberHelpers } = useField(
    `recipientDetails.accountNumber`
  );

  const onChangeClientType = () => {
    clientHelpers.setValue(undefined);
    senderAccountNumberHelpers.setValue('');
    senderAccountOwnerNameHelpers.setValue('');
    recipientAccountNumberHelpers.setValue('');
    recipientAccountOwnerNameHelpers.setValue('');
  };

  const onChangeClient: ClientAutocompleteFeatureProps['onChange'] = (
    value
  ) => {
    if (orderType === OrderOperationType.SecuritiesWithdrawal) {
      senderAccountNumberHelpers.setValue(
        value?.record?.personalAccountNumber || ''
      );
      senderAccountOwnerNameHelpers.setValue(value?.record?.name || '');
    } else if (orderType === OrderOperationType.SecuritiesDeposit) {
      recipientAccountNumberHelpers.setValue(
        value?.record?.personalAccountNumber || ''
      );
      recipientAccountOwnerNameHelpers.setValue(value?.record?.name || '');
    }
  };

  return {
    clientTypeField,
    onChangeClientType,
    onChangeClient,
  };
};
